export const INSURANCE_TITLE = 'Want to add travel insurance?'
export const TRAVEL_PROTECTION_TITLE = 'Want to add travel protection?'
